import { gql } from "@apollo/client";

export const UPDATE_BLOG = gql`
  mutation updateBlog($updateBlogInput: UpdateBlogInput!) {
    updateBlog(updateBlogInput: $updateBlogInput) {
      id
    }
  }
`;
